import {type Type} from '@packages/systems/wfdl';

import {
  TText,
  TRecord,
  TEmptyRecord,
  EText,
  ERecord,
  type Expression,
} from '@packages/systems/wfdl-ast';

export const FORM_SOURCE: {
  [key: string]: {
    tag: string;
    type: Type;
    defaultExpr: Expression;
  };
} = {
  'Default form': {
    tag: 'Default form',
    type: TEmptyRecord,
    defaultExpr: ERecord({}),
  },
  Logic: {
    tag: 'Logic',
    type: TRecord({flowId: TText}),
    defaultExpr: ERecord({flowId: EText('')}),
  },
};
